import React from 'react';

import './payments.scss';

const PaymentHeader = (props) => (
  <header className="paymentHeader">
    <i className="bi_user-lock" />
    <h4>La sicurezza delle transazioni è garantita dal nostro gateway di pagamenti</h4>
  </header>
);

export default PaymentHeader;



// WEBPACK FOOTER //
// ./src/components/payment/payment-header.js